import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replyToConversation, replyToConversationMessage, replyToDM, uploadMedia, removeMedia, updateReplyText } from 'redux/modules/messageCenter';
import * as styles from './FBReplyField.scss';
import TextField from 'material-ui/TextField';
import FBSprite from './FBSprite';
import ReactTooltip from 'react-tooltip';
import Popover from '../../Popover/Popover';
import { Picker as EmojiPicker } from 'emoji-mart';
import GiphyPicker from '../../GiphyPicker/GiphyPicker';
import Video from 'components/Video/Video'; // This needs to be like this because the react-file-picker uses "window"
// and when this file is required by the front-end server
// window will be out of scope

var FilePicker = 'div';

var FBReplyField = /*#__PURE__*/function (_Component) {
  _inherits(FBReplyField, _Component);

  var _super = _createSuper(FBReplyField);

  function FBReplyField(props) {
    var _this;

    _classCallCheck(this, FBReplyField);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleRemoveMedia", function () {
      _this.setState({
        attachedMedia: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onTextChange", function (e, value) {
      _this.setState({
        commentMessage: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clear", function () {
      _this.setState({
        popoverOpen: false,
        attachedMedia: null,
        commentMessage: ''
      });
    });

    _this.fbPage = props.orgSocialAccounts.find(function (sa) {
      return sa.platform === 'Facebook page';
    });
    _this.state = {
      popoverOpen: false,
      attachedMedia: null,
      commentMessage: ''
    };
    return _this;
  }

  _createClass(FBReplyField, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      if (FilePicker === 'div') {
        FilePicker = require('react-file-picker').FilePicker;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isReply = _this$props.isReply,
          visible = _this$props.visible;
      var avatarImageUrl = this.fbPage && this.fbPage.avatarImageUrl ? this.fbPage.avatarImageUrl : 'https://s3.amazonaws.com/likeabucket/user_upload/232/gWKDnZjH4.jpeg';
      var backgroundImage = avatarImageUrl ? "url(".concat(avatarImageUrl, ")") : '';
      return /*#__PURE__*/React.createElement("div", {
        className: isReply ? styles.replyWrap : null,
        style: _objectSpread(_objectSpread({}, this.props.style), visible ? {} : {
          display: 'none'
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.wrap,
        style: this.props.style
      }, avatarImageUrl && /*#__PURE__*/React.createElement("div", {
        className: styles.avatar,
        style: {
          backgroundImage: backgroundImage
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1,
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(TextField, {
        fullWidth: true,
        style: {
          backgroundColor: '#f2f3f5',
          border: '1px solid #ccd0d5',
          borderRadius: 16
        },
        underlineShow: false,
        inputStyle: {
          paddingRight: 10,
          paddingLeft: 10
        },
        hintStyle: {
          color: '#8d949e',
          paddingLeft: 10,
          paddingRight: 10
        },
        hintText: "Write a ".concat(isReply ? 'reply' : 'comment', "..."),
        multiLine: true,
        rows: 1,
        rowsMax: 0,
        value: this.state.commentMessage,
        onChange: this.onTextChange
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'end'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          paddingTop: 6
        }
      }, /*#__PURE__*/React.createElement(Popover, {
        open: this.state.popoverOpen === 'emoji',
        preferPlace: "above",
        content: /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            boxShadow: '0px 2px 9px #5d5d5d'
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            height: 30,
            paddingTop: 5,
            paddingBottom: 5,
            paddingLeft: 15,
            paddingRight: 15,
            justifyContent: 'end',
            display: 'flex',
            cursor: 'pointer'
          },
          onClick: function onClick() {
            _this2.setState({
              popoverOpen: false
            });
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "ion ion-close-round",
          style: {
            fontSize: 20
          }
        })), /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement(EmojiPicker, {
          "native": true,
          emoji: "",
          style: {
            border: 'none'
          },
          defaultSkin: 1,
          title: "Select an Emoji",
          onSelect: function onSelect(emoji) {
            _this2.setState({
              popoverOpen: false,
              commentMessage: "".concat(_this2.state.commentMessage).concat(emoji["native"])
            });
          }
        })))
      }, /*#__PURE__*/React.createElement(FBSprite, {
        "data-tip": true,
        "data-for": 'fbcomment-emoji',
        onClick: function onClick() {
          _this2.setState({
            popoverOpen: 'emoji'
          });
        },
        style: {
          marginRight: 9
        },
        name: "smile-light"
      })), /*#__PURE__*/React.createElement(FilePicker, {
        maxSize: 20,
        extensions: ['jpeg', 'jpg', 'png', 'tiff', 'mp4', 'mov'],
        onChange: function onChange(file) {
          var fileReader = new FileReader();
          fileReader.addEventListener('load', function () {
            console.log('read file', fileReader.result);

            _this2.setState({
              attachedMedia: {
                file: file,
                dataUrl: fileReader.result
              }
            });
          }, false);

          if (file) {
            fileReader.readAsDataURL(file);
          }

          console.log('got file', file);
        },
        onError: function onError(errMsg) {
          console.log('error string', errMsg);
          alert(errMsg);
        }
      }, /*#__PURE__*/React.createElement(FBSprite, {
        "data-tip": true,
        "data-for": 'fbcomment-media',
        style: {
          marginRight: 9
        },
        name: "camera-light"
      })), /*#__PURE__*/React.createElement(Popover, {
        open: this.state.popoverOpen === 'gif',
        preferPlace: "above",
        content: /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            boxShadow: '0px 2px 9px #5d5d5d'
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            height: 30,
            paddingTop: 5,
            paddingBottom: 5,
            paddingLeft: 15,
            paddingRight: 15,
            justifyContent: 'end',
            display: 'flex',
            cursor: 'pointer'
          },
          onClick: function onClick() {
            _this2.setState({
              popoverOpen: false
            });
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "ion ion-close-round",
          style: {
            fontSize: 20
          }
        })), /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement(GiphyPicker, {
          onSelected: function onSelected(_ref) {
            var data = _ref.downsized_large;

            _this2.setState({
              popoverOpen: false
            });

            _this2.props.submitComment('', null, data);
          },
          apiKey: "iEls0RcFp8HYRFoA15Zkp0X4FAa2hy7P"
        })))
      }, /*#__PURE__*/React.createElement(FBSprite, {
        "data-tip": true,
        "data-for": 'fbcomment-gif',
        onClick: function onClick() {
          _this2.setState({
            popoverOpen: 'gif'
          });
        },
        name: "gif-light"
      })), /*#__PURE__*/React.createElement(ReactTooltip, {
        id: 'fbcomment-emoji',
        effect: "solid"
      }, "Insert an emoji"), /*#__PURE__*/React.createElement(ReactTooltip, {
        id: 'fbcomment-media',
        effect: "solid"
      }, "Attach a photo or video"), /*#__PURE__*/React.createElement(ReactTooltip, {
        id: 'fbcomment-gif',
        effect: "solid"
      }, "Post a GIF")))), /*#__PURE__*/React.createElement("div", {
        className: styles.sendWrap
      }, !this.props.creatingComment ? /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          _this2.props.submitComment(_this2.state.commentMessage, _this2.state.attachedMedia);
        }
      }, "Send") : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        style: {
          fontSize: 22
        },
        className: "fa fa-spinner fa-spin"
      }))))), this.state.attachedMedia && this.state.attachedMedia.dataUrl && this.state.attachedMedia.file && /*#__PURE__*/React.createElement("div", {
        className: styles.mediaWrap
      }, this.state.attachedMedia.file.type.indexOf('image') !== -1 ? /*#__PURE__*/React.createElement("div", {
        className: styles.mediaPreview,
        style: {
          backgroundImage: "url('".concat(this.state.attachedMedia.dataUrl, "')")
        }
      }) : /*#__PURE__*/React.createElement(Video, {
        muted: true,
        autoPlay: true,
        loop: true,
        style: {
          objectFit: 'cover'
        },
        className: styles.mediaPreview,
        src: this.state.attachedMedia.dataUrl
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.removeMedia
      }, /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          return _this2.handleRemoveMedia();
        },
        className: "icon ion-ios-close-empty ".concat(styles.removeMediaControl)
      }))));
    }
  }]);

  return FBReplyField;
}(Component);

_defineProperty(FBReplyField, "defaultProps", {});

export { FBReplyField as default };